/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingsnav_Personaldetails2Inputs */

const zh_settingsnav_personaldetails2 = /** @type {(inputs: Settingsnav_Personaldetails2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个人详情`)
};

const en_settingsnav_personaldetails2 = /** @type {(inputs: Settingsnav_Personaldetails2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal Details`)
};

const es_settingsnav_personaldetails2 = /** @type {(inputs: Settingsnav_Personaldetails2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos personales`)
};

/**
* | output |
* | --- |
* | "Personal Details" |
*
* @param {Settingsnav_Personaldetails2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const settingsnav_personaldetails2 = /** @type {((inputs?: Settingsnav_Personaldetails2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsnav_Personaldetails2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_settingsnav_personaldetails2(inputs)
	if (locale === "en") return en_settingsnav_personaldetails2(inputs)
	return es_settingsnav_personaldetails2(inputs)
});
export { settingsnav_personaldetails2 as "settingsNav_personalDetails" }